import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { Config } from '@lmc/ts-common'

const useConfig = () => {
  const { data } = useQuery<GetConfig>(`config`, () =>
    getJSON({ url: '/api/config' })
  )

  return {
    config: data?.result,
  }
}

export type GetConfig = {
  result?: Config
}

export default useConfig
